import { useCallback } from 'react';
import { useRecoilStateLoadable } from 'recoil';
import { auctionIdsUserIsWatchingAtom } from 'recoil/atoms';
import Rest from 'services/rest';
const rest = new Rest();

export const useWatchAuction = () => {
  const [auctionIdsUserIsWatchingLoadable, set] = useRecoilStateLoadable(
    auctionIdsUserIsWatchingAtom,
  );

  const auctionIdsUserIsWatching =
    auctionIdsUserIsWatchingLoadable.valueMaybe();

  const isWatchingAuction = useCallback(
    (id: number) => (auctionIdsUserIsWatching || []).includes(id),
    [auctionIdsUserIsWatching],
  );

  const watchAuction = useCallback(
    (id: number) => {
      set([...(auctionIdsUserIsWatching || []), id]);
      return rest.watchAuction(id);
    },
    [auctionIdsUserIsWatching, set],
  );

  const unwatchAuction = useCallback(
    (id: number) => {
      set((auctionIdsUserIsWatching || []).filter((_id) => _id !== id));
      return rest.unwatchAuction(id);
    },
    [auctionIdsUserIsWatching, set],
  );

  const toggleWatchAuction = useCallback(
    (id: number) => {
      if (isWatchingAuction(id)) {
        unwatchAuction(id);
      } else {
        watchAuction(id);
      }
    },
    [isWatchingAuction, watchAuction, unwatchAuction],
  );

  return {
    toggleWatchAuction,
    watchAuction,
    unwatchAuction,
    isWatchingAuction,
  };
};
